var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMonthlyPaySeizureServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.351 57.6516L86.465 24.0947L64.6543 49.9303V110H103.351V57.6516Z",
    fill: "#BFD9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89844 56.3086H67.2329V110H7.89844V56.3086Z",
    fill: "#EAF5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5352,
    y: 72.418,
    width: 15.4786,
    height: 16.1073,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1328,
    y: 77.7852,
    width: 12.8988,
    height: 32.2146,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2178 24.0947H28.1189L7.89844 56.3094H67.2329L86.2178 24.0947Z",
    fill: "#BEBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4685 11.9374C44.7059 5.62502 49.6034 -1.59419e-08 55.9617 -3.37824e-08C62.3099 -5.1595e-08 67.2038 5.60591 66.4476 11.909C65.373 20.8674 64.1245 32.6811 64.1245 39.2192C64.1245 50.698 67.9727 61.2202 67.9727 61.2202L43.9219 61.2202C43.9219 61.2202 47.77 51.1732 47.77 39.2192C47.77 32.4561 46.5383 20.792 45.4685 11.9374Z",
    fill: "#A26138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3418 60.459C29.3418 51.6224 36.5052 44.459 45.3418 44.459L66.5451 44.459C75.3816 44.459 82.5451 51.6224 82.5451 60.459L82.5451 63.4081L29.3418 63.4081L29.3418 60.459Z",
    fill: "#A26C4D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8848,
    y: 61.2168,
    width: 56.1185,
    height: 5.8305,
    rx: 2,
    fill: "#845430"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonthlyPaySeizureServiceMain);
export default __webpack_public_path__ + "static/media/IcMonthlyPaySeizureServiceMain.df6052e69aa262333d0711d1a1dec30c.svg";
export { ForwardRef as ReactComponent };